var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2811,
    height: 2310,
    viewBox: "0 0 2811 2310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2607.35 158.057C1861.13 571.127 874.146 -254.119 127.045 158.057C-620.056 570.234 127.045 -137.566 127.045 -137.566H2607.35C2607.35 -137.566 3353.56 -255.012 2607.35 158.057Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2621.35 222.057C1875.13 635.127 888.146 -190.119 141.045 222.057C-606.056 634.234 141.045 -73.5662 141.045 -73.5662H2621.35C2621.35 -73.5662 3367.56 -191.012 2621.35 222.057Z",
    fill: "#6C63FF",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2621.35 283.057C1875.13 696.127 888.146 -129.119 141.045 283.057C-606.056 695.234 141.045 -12.5662 141.045 -12.5662H2621.35C2621.35 -12.5662 3367.56 -130.012 2621.35 283.057Z",
    fill: "#6C63FF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2621.35 346.094C1875.13 791.082 888.146 -97.9324 141.045 346.094C-606.056 790.12 141.045 27.6264 141.045 27.6264H2621.35C2621.35 27.6264 3367.56 -98.8945 2621.35 346.094Z",
    fill: "#6C63FF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2621.35 404.438C1875.13 841.916 888.146 -32.0938 141.045 404.438C-606.056 840.97 115 -6.99999 115 -6.99999L2674 -7C2674 -7 3367.56 -33.0397 2621.35 404.438Z",
    fill: "#6C63FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2628.24 478.733C1882.02 916.211 895.036 42.2008 147.934 478.733C-599.167 915.265 1.49979 3.5 1.49979 3.5L2796 -17.5C2796 -17.5 3374.45 41.2549 2628.24 478.733Z",
    fill: "#6C63FF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2642.08 550.233C1895.87 987.711 908.879 113.701 161.778 550.233C-585.323 986.765 -32.0001 -22 -32.0001 -22L2945 -82.5C2945 -82.5 3388.3 112.755 2642.08 550.233Z",
    fill: "#6C63FF",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2811,
    height: 2310,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDark);
export default __webpack_public_path__ + "static/media/homeDark.0b49ef25350c8ccb7509ef906557ce87.svg";
export { ForwardRef as ReactComponent };